import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HeaderService } from 'src/app/system-common/services/header.service';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { GamificationService } from '../services/gamification.service';
import { GamificationInquiryHandler } from './gamification-inquiry.handler';

@Component({
  selector: 'sym-gamification-inquiry',
  templateUrl: './gamification-inquiry.component.html',
  styleUrls: ['./gamification-inquiry.component.scss'],
})
export class GamificationInquiryComponent extends GamificationInquiryHandler {
  constructor(
    public service: GamificationService,
    public headerService: HeaderService,
    public router: Router,
    public settingService: SettingService,
    public route: ActivatedRoute
  ) {
    super(service, headerService, router, settingService, route);
  }

  ngOnInit() {
    super.ngOnInit();
  }
}
